export const goAgreeTermsPage = (token: string, redirectUrl: string) => {
  if (typeof window === 'undefined') return;
  window.location.replace(
    `${window.location.origin}/accounts/agree-terms?token=${encodeURI(
      token,
    )}&redirectURL=${encodeURI(redirectUrl)}`,
  );
};
